import type { Result } from "./CasesContent";
import CountUp from "../../components/CountUp/CountUp";

type CaseStatsProps = {
  results: (Result & { accent?: boolean })[];
  state: string; // sufixo de classe do useInView do case
};

// Faixa de números do case: valores grandes que contam ao aparecer, separados por linhas finas.
export default function CaseStats({ results, state }: CaseStatsProps) {
  return (
    <ul className="cz-case-panel__stats" style={{ "--count": results.length } as React.CSSProperties}>
      {results.map((result, i) => (
        <li key={result.value} className="cz-case-panel__stat" data-reveal style={{ "--i": i } as React.CSSProperties}>
          <strong className={`cz-case-panel__value${result.accent ? " is-accent" : ""}`}>
            <CountUp value={result.value} state={state} />
          </strong>
          <span className="cz-case-panel__stat-label">{result.label}</span>
        </li>
      ))}
    </ul>
  );
}
